import { AWS_REGIONS } from "./constants";
import * as Yup from 'yup'

// Single CIDR block: octets 0-255 and a /0-32 prefix, e.g. 172.31.0.0/16
const CIDR = '(?:25[0-5]|2[0-4]\\d|1?\\d?\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1?\\d?\\d)){3}/(?:3[0-2]|[12]?\\d)';
// One or more comma-separated CIDR blocks (optional spaces around commas)
const CIDR_LIST_REGEX = new RegExp(`^${CIDR}(?:\\s*,\\s*${CIDR})*$`);
export const initialValues = {
  name: '',
  vpc_id: '',
  cidr_range: '',
  aws_account_id: '',
  aws_region: AWS_REGIONS[0].value
}

export const validationSchema = Yup.object({
  name: Yup.string().trim().required(),
  vpc_id: Yup.string().trim().required(),
  cidr_range: Yup.string().trim()
    .matches(CIDR_LIST_REGEX, 'Enter valid CIDR(s), comma-separated. e.g. 172.31.0.0/16, 10.0.0.0/24')
    .required(),
  aws_account_id: Yup.string().trim()
    .matches(/^\d{12}$/, 'AWS Account ID must be exactly 12 digits')
    .required(),
  aws_region: Yup.string().required()
})